/* eslint-disable @typescript-eslint/no-unnecessary-condition */

/**Map zoom levels (values must be between 0 and 22)*/
export const ZOOM_50_PERCENT = 11;
export const ZOOM_60_PERCENT = 13;
export const ZOOM_68_PERCENT = 15;
export const ZOOM_75_PERCENT = 17;
export const ZOOM_80_PERCENT = 18;
export const ZOOM_85_PERCENT = 19;
export const ZOOM_MAX = 23;

const getZoomValue = (defaultValue: number, windowEnvValue?: string): number => {
  if (!windowEnvValue) {
    return defaultValue;
  }

  const parsedValue = parseInt(windowEnvValue, 10);
  if (!isNaN(parsedValue)) {
    return parsedValue;
  }
  return defaultValue;
};

export const SHOW_ON_MAP_BUTTON_ZOOM = getZoomValue(ZOOM_75_PERCENT, window.env?.VITE_SHOW_ON_MAP_BUTTON_ZOOM);

export const SHOW_TARGET_MIN_ZOOM_EXCEPT_DRONE_AIRPLANE = getZoomValue(
  ZOOM_50_PERCENT,
  window.env?.VITE_SHOW_TARGET_MIN_ZOOM_EXCEPT_DRONE_AIRPLANE,
);

export const SHOW_TARGET_STROBE_MAX_ZOOM = getZoomValue(ZOOM_85_PERCENT, window.env?.VITE_SHOW_TARGET_STROBE_MAX_ZOOM);

export const SHOW_PERMANENT_TOOLTIP_MIN_ZOOM = getZoomValue(
  ZOOM_68_PERCENT,
  window.env?.VITE_SHOW_PERMANENT_TOOLTIP_MIN_ZOOM,
);

export const SHOW_LAD_SENSOR_MIN_ZOOM = getZoomValue(ZOOM_68_PERCENT, window.env?.VITE_SHOW_LAD_SENSOR_MIN_ZOOM);

export const SHOW_STATISTIC_POINT_MIN_ZOOM = getZoomValue(
  ZOOM_60_PERCENT,
  window.env?.VITE_SHOW_STATISTIC_POINT_MIN_ZOOM,
);

export const SHOW_PERIMETER_SENSOR_MIN_ZOOM = getZoomValue(
  ZOOM_80_PERCENT,
  window.env?.VITE_SHOW_PERIMETER_SENSOR_MIN_ZOOM,
);

export const SHOW_AUTOMATON_SECTION_MIN_ZOOM = getZoomValue(
  ZOOM_50_PERCENT,
  window.env?.VITE_SHOW_AUTOMATON_SECTION_MIN_ZOOM,
);
export const SHOW_AUTOMATON_SECTION_MID_ZOOM = getZoomValue(
  ZOOM_68_PERCENT,
  window.env?.VITE_SHOW_AUTOMATON_SECTION_MID_ZOOM,
);
export const SHOW_AUTOMATON_SECTION_MAX_ZOOM = getZoomValue(
  ZOOM_80_PERCENT,
  window.env?.VITE_SHOW_AUTOMATON_SECTION_MAX_ZOOM,
);

export const SHOW_PERIMETER_PORTAL_MIN_ZOOM = getZoomValue(
  ZOOM_60_PERCENT,
  window.env?.VITE_SHOW_PERIMETER_PORTAL_MIN_ZOOM,
);

export const SHOW_PERIMETER_CAMERA_MIN_ZOOM = getZoomValue(
  ZOOM_75_PERCENT,
  window.env?.VITE_SHOW_PERIMETER_CAMERA_MIN_ZOOM,
);
export const SHOW_PERIMETER_CAMERA_MAX_ZOOM = getZoomValue(
  ZOOM_80_PERCENT,
  window.env?.VITE_SHOW_PERIMETER_CAMERA_MAX_ZOOM,
);

export const SHOW_LAD_CAMERA_STROBE_MAX_ZOOM = getZoomValue(ZOOM_MAX, window.env?.VITE_SHOW_LAD_CAMERA_STROBE_MAX_ZOOM);

export const SHOW_RADAR_COVERAGE_MAX_ZOOM = getZoomValue(
  ZOOM_85_PERCENT,
  window.env?.VITE_SHOW_RADAR_COVERAGE_MAX_ZOOM,
);

export const ROUND_SECTION_ZOOM_LIMIT_FOR_WIDTH = getZoomValue(
  ZOOM_60_PERCENT,
  window.env?.VITE_ROUND_SECTION_ZOOM_LIMIT_FOR_WIDTH,
);
